import React from 'react';
import { GridToolbarContainer, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';

export function SensorMappingCustomToolbar(): JSX.Element {
  return (
    <GridToolbarContainer>
      <div className="project-grid-toolbar-title">Sensor Mapping</div>

      <div className="project-grid-toolbar-filters">
        <GridToolbarQuickFilter />
        <GridToolbarDensitySelector />
      </div>
    </GridToolbarContainer>
  );
}
